import L from 'leaflet';

export default class TargetPin extends L.Marker
{
	constructor(latlng, options = {})
	{
		const userPinIcon = L.divIcon(
		{
			className: 'target-pin',
			html: `<div class="pin-inner">
						<div class="circle"></div>
						<div class="pulses">
							<div class="pulse"></div>
							<div class="pulse"></div>
						</div>
					</div>`,
			iconSize: [25, 25]
		}
		);

		super(latlng,
		{
			...options,
			icon: userPinIcon,
			pane: 'user'
		}
		);

		this._active = false;
	}

	get active()
	{
		return this._active;
	}

	set active(value)
	{
		this._active = value;
		if (value)
		{
			this.getElement().classList.add('active');
		}
		else
		{
			this.getElement().classList.remove('active');
		}
	}
}